import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Porting'
      breadcrumbs={[
        {
          label: 'Onboarding',
        },
        {
          label: 'Porting',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/onboarding/porting',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
